<lib-social-wall-widget
  [title]="data.title"
  [channelList]="data.social_wall"
  [animation]="data.animation"
  [animationDelay]="data.animationDelay"
  (seeAllPosts)="navigateToSocialWall($event)">
</lib-social-wall-widget>
